var _rect, _rect2, _rect3, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFollowUpsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    rx: 21.5,
    fill: "white",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    rx: 21.5,
    fill: "url(#paint0_linear_597_35252)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    rx: 21.5,
    fill: "url(#paint1_linear_597_35252)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.375 10.25C19.8832 10.25 18.4524 10.8426 17.3975 11.8975C16.3426 12.9524 15.75 14.3832 15.75 15.875C15.75 17.3668 16.3426 18.7976 17.3975 19.8525C18.4524 20.9074 19.8832 21.5 21.375 21.5C22.8668 21.5 24.2976 20.9074 25.3525 19.8525C26.4074 18.7976 27 17.3668 27 15.875C27 14.3832 26.4074 12.9524 25.3525 11.8975C24.2976 10.8426 22.8668 10.25 21.375 10.25ZM21.375 22.625C18.6806 22.625 16.2281 23.4057 14.4248 24.5049C13.5247 25.0561 12.7553 25.703 12.1995 26.4061C11.6528 27.0991 11.25 27.9271 11.25 28.8125C11.25 29.7631 11.7124 30.5124 12.3784 31.0467C13.0084 31.553 13.8397 31.8882 14.7229 32.1222C16.4981 32.5914 18.8674 32.75 21.375 32.75C21.6337 32.75 21.8925 32.7478 22.1456 32.7444C22.334 32.7418 22.5188 32.6919 22.6829 32.5993C22.847 32.5068 22.9853 32.3744 23.0849 32.2145C23.1846 32.0546 23.2425 31.8722 23.2533 31.6841C23.2641 31.496 23.2275 31.3082 23.1469 31.1379C22.7193 30.2353 22.4983 29.2487 22.5 28.25C22.5 26.8415 22.9309 25.5365 23.6666 24.4554C23.776 24.2947 23.8419 24.1085 23.8578 23.9148C23.8738 23.7211 23.8393 23.5265 23.7577 23.3501C23.6762 23.1737 23.5503 23.0215 23.3924 22.9082C23.2344 22.7949 23.0499 22.7245 22.8566 22.7037C22.3729 22.652 21.8779 22.625 21.375 22.625ZM33.4215 26.0765C33.6264 25.8643 33.7398 25.5801 33.7373 25.2852C33.7347 24.9902 33.6164 24.708 33.4078 24.4995C33.1992 24.2909 32.917 24.1726 32.6221 24.17C32.3271 24.1674 32.0429 24.2808 31.8308 24.4858L28.251 28.0655L26.6602 26.4748C26.4481 26.2698 26.1639 26.1564 25.8689 26.159C25.574 26.1616 25.2918 26.2799 25.0832 26.4885C24.8746 26.697 24.7563 26.9792 24.7537 27.2742C24.7512 27.5691 24.8646 27.8533 25.0695 28.0655L27.3757 30.3717C27.4907 30.4867 27.6271 30.5779 27.7773 30.6402C27.9275 30.7024 28.0884 30.7344 28.251 30.7344C28.4136 30.7344 28.5745 30.7024 28.7247 30.6402C28.8749 30.5779 29.0113 30.4867 29.1262 30.3717L33.4215 26.0765Z",
    fill: "#FBFBFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_597_35252",
    x1: 0,
    y1: 21.5,
    x2: 43,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDA085"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_597_35252",
    x1: 21.5,
    y1: 0,
    x2: 21.5,
    y2: 43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAAEFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9153F4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowUpsIcon);
export default __webpack_public_path__ + "static/media/followUps-icon.05233e27e6f9d17b9c6bef194b6ecf2d.svg";
export { ForwardRef as ReactComponent };